import UserComment from "@/components/elements/activityFeed/elements/userComment/UserComment"

const Complaint = ({complaintText, zIndex, isPopOut}: {complaintText?: string | null, zIndex?: number, isPopOut?: boolean }) => {
    const truncation = isPopOut ?  50 : 10000
    const classname = isPopOut ? "flagged-comment-detail-text" : "full-screen-styling flagged-comment-detail-text"

    if (!complaintText) {
        return
    }

    return (
        <UserComment 
            zIndexNum={zIndex} 
            className={classname} 
            commentText={complaintText} 
            truncateNumber={truncation}
            hideMenu={true}
        />
    )
}
export default Complaint